// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
table,td,th{
  white-space: nowrap;
  text-align: left !important;
}

select{
  background-color: white;
  font-weight:  normal !important;
}

.partslists_containers .fangledowndiv {
  display: flex;
  align-items: center;
  gap: 0.2rem;
}
.text_count{
z-index: 4;
font-size: 13px;
}
.pgm-list-header-text {
  font-family: "Nunito";
  font-size: 12px;
  font-weight: 500;
  color: #2D2D2D;
  padding: 0.5rem;
}
.video_image{
  padding: 1rem !important;
 }
 .pdf_image{
  padding: 0.8rem !important;
 }
 .module_thumbnails{
  padding: 1.4rem !important;
 }
/* th{
  display: flex;
  /* flex-direction: column; */
  /* align-items: center; */
/* } */ 



.tablesth span{
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  background: #0c3688 !important;
  color: white !important;
}

.flex_updown{
  display: flex !important;
  align-items: center !important;
  justify-content: left;
} 
/* .icon_flex{
  display: flex !important;
  flex-direction: column !important;
  cursor: pointer !important;
  font-size: 12px;
}  */

/* .sidebar{
  height: 100vh;
} */

html[dir="rtl"] label {
  position: absolute;
  right: 25px !important;
  left: auto !important;
}

html[dir="rtl"] .country-label {
  left: auto !important;
  right: 28px !important;
}
html[dir="rtl"] .language-label {
  left: auto !important;
  right: 28px !important;
}

html[dir="rtl"] .pass-icon {
  right: auto !important;
  left: 44px !important;
}

html[dir="rtl"] table {
  text-align: right !important;
}

html[dir="rtl"] td {
  text-align: right !important;
}
html[dir="rtl"] th {
  text-align: right !important;
}
html[dir="rtl"] .parts_add_textfields .multiselect_part {
  margin-right: 10px !important;
  margin-left: auto !important;
}

html[dir="rtl"] .text_count_name_add_parts_page{
  right: 91%;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;AACA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;AACA,UAAU;AACV,eAAe;AACf;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,wBAAwB;CACzB;CACA;EACC,0BAA0B;CAC3B;CACA;EACC,0BAA0B;CAC3B;AACD;;8BAE8B;EAC5B,yBAAyB;AAC3B,MAAM;;;;AAIN;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;;;;;IAKI;;AAEJ;;GAEG;;AAEH;EACE,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\ntable,td,th{\n  white-space: nowrap;\n  text-align: left !important;\n}\n\nselect{\n  background-color: white;\n  font-weight:  normal !important;\n}\n\n.partslists_containers .fangledowndiv {\n  display: flex;\n  align-items: center;\n  gap: 0.2rem;\n}\n.text_count{\nz-index: 4;\nfont-size: 13px;\n}\n.pgm-list-header-text {\n  font-family: \"Nunito\";\n  font-size: 12px;\n  font-weight: 500;\n  color: #2D2D2D;\n  padding: 0.5rem;\n}\n.video_image{\n  padding: 1rem !important;\n }\n .pdf_image{\n  padding: 0.8rem !important;\n }\n .module_thumbnails{\n  padding: 1.4rem !important;\n }\n/* th{\n  display: flex;\n  /* flex-direction: column; */\n  /* align-items: center; */\n/* } */ \n\n\n\n.tablesth span{\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  background: #0c3688 !important;\n  color: white !important;\n}\n\n.flex_updown{\n  display: flex !important;\n  align-items: center !important;\n  justify-content: left;\n} \n/* .icon_flex{\n  display: flex !important;\n  flex-direction: column !important;\n  cursor: pointer !important;\n  font-size: 12px;\n}  */\n\n/* .sidebar{\n  height: 100vh;\n} */\n\nhtml[dir=\"rtl\"] label {\n  position: absolute;\n  right: 25px !important;\n  left: auto !important;\n}\n\nhtml[dir=\"rtl\"] .country-label {\n  left: auto !important;\n  right: 28px !important;\n}\nhtml[dir=\"rtl\"] .language-label {\n  left: auto !important;\n  right: 28px !important;\n}\n\nhtml[dir=\"rtl\"] .pass-icon {\n  right: auto !important;\n  left: 44px !important;\n}\n\nhtml[dir=\"rtl\"] table {\n  text-align: right !important;\n}\n\nhtml[dir=\"rtl\"] td {\n  text-align: right !important;\n}\nhtml[dir=\"rtl\"] th {\n  text-align: right !important;\n}\nhtml[dir=\"rtl\"] .parts_add_textfields .multiselect_part {\n  margin-right: 10px !important;\n  margin-left: auto !important;\n}\n\nhtml[dir=\"rtl\"] .text_count_name_add_parts_page{\n  right: 91%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
